import axiosInstance from "../../../utils/axios";

const commonPath = "common";

export const GlobalSettingsDetails = async () => {
  return await axiosInstance().get(`${commonPath}/global-settings`);
};
export const menuOptions = async (values) => {
  return await axiosInstance().post(`${commonPath}/cms-option`,values);
}
export const FaqList = async (values) => {
  return await axiosInstance().post(`${commonPath}/faq-list`,values);
}
export const cmsDetails = async (data) => {
    return await axiosInstance().get(`${commonPath}/cms-page?slug=${data}`);
}
export const saveContactUs = async (values) => {
    return await axiosInstance().post(`${commonPath}/add-inquiry`,values);
}